import React from 'react';
import propTypes from 'prop-types';
import { Routes, Route, useLocation } from 'react-router-dom';
import { VendorEditPageWrapper } from 'src/vendor/views/VendorEditPageWrapper';
import { AllVendorsListPage } from './AllVendorsListPage';

export function AllVendorsPage({ isExpanded }) {
  const location = useLocation();
  return (
    <Routes location={location}>
      <Route
        path=""
        exact
        element={<AllVendorsListPage isExpanded={isExpanded} />}
      />
      <Route
        path="add"
        element={<VendorEditPageWrapper isExpanded={isExpanded} isAllVendors />}
      />
      <Route
        path="edit/:id"
        element={<VendorEditPageWrapper isExpanded={isExpanded} isAllVendors />}
      />
    </Routes>
  );
}

AllVendorsPage.propTypes = {
  isExpanded: propTypes.bool.isRequired,
};
